export default __webpack_public_path__ + "static/media/offline17.24209e49.png";